'use client'

export {default} from '@fitro/customer-features/routes/NotFound'
